export default {
  title: 'Nueva máscara',
  title_edit: 'Editando máscara',
  help: 'Ayuda',
  howToTitle: 'Cómo crear patrones de máscaras',
  forNumbers: 'Para números',
  forLetters: 'Para letras',
  forAlphanumeric: 'Para alfanuméricos',
  name: 'Nombre*',
  pattern: 'Máscara*',
  playground: 'Playground',
  applied: '(aplicado: {{pattern}})'
}
